import React, { useEffect, useState } from 'react';
import 'react-quill-new/dist/quill.snow.css';
import privateAxios from '../../utils/axios/privateAxios';
import publicAxios from '../../utils/axios/publicAxios';
import './AddToGallery.css';
import Notification from '../../components/Notification/Notification';
import { Link, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';


const AddToGallery = () => {
    const navigate = useNavigate();

    const [decodedData, setDecodedData] = useState({});
    const userRoles = decodedData?.userRoles || [];
    const [title, setTitle] = useState('');
    const [display, setDisplay] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState('');
    const [notification, setNotification] = useState({ type: '', message: '' });

    const showNotification = (type, message) => {
        setNotification({ type, message });
        setTimeout(() => {
            setNotification({ type: '', message: '' });
        }, 5000);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setImageFile(file);
        setPreviewUrl(URL.createObjectURL(file));
    };

    const uploadImageToS3 = async () => {
        if (!imageFile) return '';

        try {
            const response = await privateAxios.get('/private/generate-upload-url', {
                params: {
                    filename: imageFile.name,
                    filetype: imageFile.type,
                },
            });

            const { url } = response.data;
            await publicAxios.put(url, imageFile);

            return url.split('?')[0];
        } catch (error) {
            console.error('Image upload failed:', error);
            throw new Error('Failed to upload image.');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus('');

        try {
            let uploadedImageUrl = '';
            if (imageFile) {
                uploadedImageUrl = await uploadImageToS3();
            }

            const postData = {
                title,
                display,
                imageUrl: uploadedImageUrl || '',
            };

            await privateAxios.post(`/private/add-to-gallery`, postData);

            showNotification('success', 'Added to gallery successfully!');
            setTitle('');
            setDisplay(false);
            setImageFile(null);
            setPreviewUrl('');

            // setTimeout(() => navigate('/admin-gallery'), 3000);
        } catch (error) {
            console.error(error);
            showNotification('error', error.message || 'Error adding to gallery.');
            setStatus('Error adding to gallery.');
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        const token = localStorage.getItem('token');

        // Ensure token exists before decoding
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setDecodedData(decoded);
            } catch (err) {
                console.error('Invalid token:', err);
                // Handle invalid token if necessary (e.g., redirect to login)
                navigate('/login');
            }
        }
    }, [navigate]);

    return (
        <div className="add-to-gallery">
            <Notification
                type={notification.type}
                message={notification.message}
                onClose={() => setNotification({ type: '', message: '' })}
            />

            <Link to={'/admin-gallery'} className="add-to-gallery-back-to-gallery">
                Back to Gallery
            </Link>

            <h2>Add to Gallery</h2>

            <form onSubmit={handleSubmit}>
                <label>Title:</label>
                <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                />

                {userRoles.includes('admin') && (
                    <label className="checkbox-label">
                        <input
                            type="checkbox"
                            checked={display}
                            onChange={() => setDisplay(!display)}
                        />
                        Display
                    </label>
                )}

                <label>Upload Image:</label>
                <input type="file" accept="image/*" onChange={handleImageChange} />
                {previewUrl && (
                    <div className="uploaded-image-preview">
                        <img src={previewUrl} alt="Selected preview" />
                    </div>
                )}

                <button type="submit" disabled={loading}>
                    {loading ? 'Adding...' : 'Add'}
                </button>
            </form>

            {status && <p className="status-message">{status}</p>}
        </div>
    );
};

export default AddToGallery;